/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type TopicSelector_viewer$ref = any;
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type MediaGalleryList_viewer$ref: FragmentReference;
export type MediaGalleryList_viewer = {|
  +mediaFiles: ?{|
    +totalCount: ?number,
    +mediaFiles: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +filename: ?string,
      +description: ?string,
      +alt: ?string,
      +show: ?string,
      +topics: ?$ReadOnlyArray<?{|
        +id: string
      |}>,
      +type: MediaFileTypeEnum,
      +preview: ?string,
      +status: ?string,
      +updatedAt: ?string,
      +seoTitle: ?string,
      +seoDescription: ?string,
      +seoKeywords: ?string,
      +slug: ?string,
    |}>,
  |},
  +topics: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |}
    |}>
  |},
  +$fragmentRefs: TopicSelector_viewer$ref,
  +$refType: MediaGalleryList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "MediaGalleryList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "topic",
      "type": "ID",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "searchText",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "show",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "types",
      "type": "[MediaFileTypeEnum]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sort",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[MediaFileStateType]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "mediaFiles",
      "name": "mediaFilesPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 21,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "searchText",
          "variableName": "searchText",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "show",
          "variableName": "show",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "sort",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[MediaFileStateType]"
        },
        {
          "kind": "Variable",
          "name": "topic",
          "variableName": "topic",
          "type": "ID"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "types",
          "type": "[MediaFileTypeEnum]"
        }
      ],
      "concreteType": "mediaFilesPaginate",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaFiles",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaFile",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "filename",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "alt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "show",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "topics",
              "storageKey": null,
              "args": null,
              "concreteType": "Topic",
              "plural": true,
              "selections": [
                v0
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "preview",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "updatedAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "seoTitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "seoDescription",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "seoKeywords",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "slug",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "topics",
      "name": "topics",
      "storageKey": "topics(first:-1)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": -1,
          "type": "Int"
        }
      ],
      "concreteType": "TopicConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TopicEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Topic",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "TopicSelector_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd6f1787bca6bdba4ae6b85aaea859f03';
module.exports = node;



// WEBPACK FOOTER //
// src/components/media/__generated__/MediaGalleryList_viewer.graphql.js